<template>
  <div id="contenedor-eliminar-auditoria-informe">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Informe </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el Informe? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{informe.numeroOficio}}
          </span>
        </v-row>
        <v-row>
          <span> <cortar-texto
          :texto="informe.nombre">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarAuditoriaInforme"
          :disabled="enviandoFormulario || tieneDependencias || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import mixInformes from './mixInformes';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContenedorEliminarAuditoriaInforme',
  props: {
    informe: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixInformes],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarAuditoriaInforme() {
      this.enviandoFormulario = true;
      this.mixEliminarAuditoriaInforme();
    },
  },
  computed: {
    tieneDependencias() {
      return this.informe.observaciones.length > 0;
    },
  },
};
</script>
